import { Injectable } from '@angular/core';
import { FilterFieldValue, FilterFieldType } from '../../covance-filter';

@Injectable()
export class AdminEQueryEscalationsFilterResolver {
    public readonly escalationSentTimeQueryParam = 'escalationSentTime';

    public filterDefinitions(): FilterFieldValue[] {
        return [
            this.escalationSentTime(),
        ];
    }

    private escalationSentTime(): FilterFieldValue {
        return {
            def: {
                title: 'Escalation Sent Time',
                queryParam: this.escalationSentTimeQueryParam,
                isServerSideFilter: true,
                type: FilterFieldType.DateTimeRange,
            },
        };
    }
}
